/**
 * Contexto da área: quem sou eu, a equipe, a configuração e permissões.
 * Junta auth + consultas e expõe utilidades de nomes.
 */
import { createContext, useContext } from 'react';
import { type User, type WorkspaceSettings, canWrite as roleCanWrite } from '@quadro/domain';

export interface Workspace {
  me: User;
  people: User[];
  /** pessoas ativas (para atribuir tarefas) */
  members: User[];
  settings: WorkspaceSettings;
  canWrite: boolean;
  isAdmin: boolean;
  person: (id: string) => { name: string; color: string | null };
  firstName: (id: string) => string;
}

export const WorkspaceContext = createContext<Workspace | null>(null);

export function useWorkspace(): Workspace {
  const w = useContext(WorkspaceContext);
  if (!w) throw new Error('useWorkspace fora do WorkspaceProvider');
  return w;
}

export function buildWorkspace(me: User, people: User[], settings: WorkspaceSettings): Workspace {
  const byId = new Map(people.map(p => [p.id, p]));
  const person = (id: string) => {
    const p = byId.get(id);
    return { name: p?.name || (id === me.id ? 'Você' : 'Alguém'), color: p?.color ?? null };
  };
  return {
    me, people, members: people.filter(p => p.active), settings,
    canWrite: roleCanWrite(me) && me.active, isAdmin: me.role === 'admin' && me.active,
    person, firstName: id => person(id).name.split(' ')[0],
  };
}
